import { render, staticRenderFns } from "./YearOverviewPerMonthSettings.vue?vue&type=template&id=2b8dd9e7&scoped=true"
import script from "./YearOverviewPerMonthSettings.vue?vue&type=script&lang=ts"
export * from "./YearOverviewPerMonthSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8dd9e7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b8dd9e7')) {
      api.createRecord('2b8dd9e7', component.options)
    } else {
      api.reload('2b8dd9e7', component.options)
    }
    module.hot.accept("./YearOverviewPerMonthSettings.vue?vue&type=template&id=2b8dd9e7&scoped=true", function () {
      api.rerender('2b8dd9e7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/YearOverviewPerMonthSettings.vue"
export default component.exports